import {BewerbSpielSatz} from "@/services/data/meisterschaften/bewerbSpielSatz";

export class BewerbSpiel {
    constructor(spiel, id, anzahlSaetze, label, isLooserGame) {
        this.id = spiel?.id??id;
        this.team1 = spiel?.team1??null;
        this.team2 = spiel?.team2??null;
        this.team1Status = spiel?.team1Status??'finished';
        this.team2Status = spiel?.team2Status??'finished';
        this.sv1 = spiel?.sv1??null;
        this.sv2 = spiel?.sv2??null;
        const saetze = {}
        for ( let i = 1; i <= anzahlSaetze; i++ ) {
            saetze[i] = new BewerbSpielSatz( spiel?.saetze[i]??null,i, )
        }
        this.saetze = saetze;
        this.winner = spiel?.winner??'';
        this.team1Freilos = spiel?.team1Freilos??undefined;
        this.team2Freilos = spiel?.team2Freilos??undefined;
        this.kommentar = spiel?.kommentar??'';
        this.label = spiel?.label??label;
        if ( isLooserGame || spiel?.isLooserGame ) this.isLooserGame = spiel?.isLooserGame??isLooserGame;
    }

    hasFreilos() {
        return this.team1Freilos || this.team2Freilos
    }

    teamsAreSet() {
        return this.team1 && this.team2
    }

    getSaetzeList(){
        return Object.values(this.saetze).sort((a, b) => a.id > b.id ? 1 : -1);
    }

    getSatzPunkteByTeam() {
        let team1 = {kegel: 0, sp: 0};
        let team2 = {kegel: 0, sp: 0};
        Object.values(this.saetze).forEach( (satz) => {
            team1.sp += satz.getSatzPunkte(1);
            team2.sp += satz.getSatzPunkte(2);
            team1.kegel += satz.k1;
            team2.kegel += satz.k2;
        })
        return {team1, team2};
    }

    showSVPunkte() {
        if ( this.sv1 > 0 || this.sv2 > 0 ) return true
        for ( let i = 1; i <= Object.values(this.saetze).length; i++ ) {
            const satz = this.saetze[i]
            if ( satz.sv1 > 0 || satz.sv2 > 0 ) return true
        }
        return false
    }

    getSpielResult(settingsSpiel) {
        const satzPunkte = this.getSatzPunkteByTeam();
        const spSv1 = this.sv1 > this.sv2 ? 1 : 0;
        const spSv2 = this.sv2 > this.sv1 ? 1 : 0;
        const sp1 = satzPunkte.team1.sp + spSv1;
        const sp2 = satzPunkte.team2.sp + spSv2
        const spTotal = sp1 + sp2
        const completed = (spTotal === settingsSpiel.saetze && satzPunkte.team1.sp !== satzPunkte.team2.sp) ||
                           spTotal > settingsSpiel.saetze;
        const winner1 = completed && (sp1 > sp2 && this.team1Status === 'finished') ||
                                     (this.team1Status === 'finished' && this.team2Status !== 'finished')
        const winner2 = completed && (sp2 > sp1 && this.team2Status === 'finished') ||
                                     (this.team2Status === 'finished' && this.team1Status !== 'finished')
        return { sp1, sp2, spSv1, spSv2, completed, winner1, winner2,
            winnerTeam: winner1 ? 'team1' : winner2 ? 'team2' :
                        this.team1Status !== 'finished' && this.team2Status !== 'finished' ? 'freilos' : '',
            kegel1: satzPunkte.team1.kegel,
            kegel2: satzPunkte.team2.kegel,
            showSpielSV: satzPunkte.team1.sp + satzPunkte.team2.sp === settingsSpiel.saetze &&
                         satzPunkte.team1.sp === satzPunkte.team2.sp,
            showSVSpalte: this.showSVPunkte(),
        }
    }

    getResultUpdateObject(spielPfad, winnerTeam) {
        this.sv1 =  this.sv1 !== null ? parseInt(this.sv1) : null
        this.sv2 =  this.sv2 !== null ? parseInt(this.sv2) : null
        const dataObject = {
            [spielPfad + '.sv1']: this.sv1,
            [spielPfad + '.sv2']: this.sv2,
            [spielPfad + '.saetze']: {},
            [spielPfad + '.team1Status']: this.team1Status,
            [spielPfad + '.team2Status']: this.team2Status,
            [spielPfad + '.kommentar']: this.kommentar,
        }
        Object.values(this.saetze).forEach( (satz) => {
            const satzObject = {
                id: satz.id,
                k1: parseInt(satz.k1),
                k2: parseInt(satz.k2),
                sv1: satz.sv1 !== null ? parseInt(satz.sv1) : null,
                sv2: satz.sv2 !== null ? parseInt(satz.sv2) : null,
            }
            dataObject[spielPfad + '.saetze'][satz.id] = satzObject
            this.saetze[satz.id] = new BewerbSpielSatz(satzObject)
        })
        dataObject[spielPfad + '.winner'] = winnerTeam
        this.winner = winnerTeam
        return dataObject
    }

    suddenVictoryIsTied() {
        return this.sv1 == this.sv2 && this.sv1 !== null && this.sv2 !== null;
    }

    cleanSuddenVictory(spielSettings) {
        const showSpielSV = this.getSpielResult(spielSettings).showSpielSV
        if ( !showSpielSV ) {
            this.sv1 = null
            this.sv2 = null
        }
        Object.values(this.saetze).forEach( (satz) => {
            if ( !satz.suddenVictoryRequired() ) {
                satz.sv1 = null
                satz.sv2 = null
            }
        })
    }

    clear(){
        this.team1 = null
        this.team2 = null
        this.team1Freilos = undefined
        this.team2Freilos = undefined
        this.clearResult()
    }

    clearResult(){
        this.sv1 = null
        this.sv2 = null
        this.winner = ''
        this.team1Status = 'finished'
        this.team2Status = 'finished'
        this.kommentar = ''
        this.clearAllSaetze()
    }

    clearAllSaetze(){
        Object.values(this.saetze).forEach( (satz) => {
            satz.clear()
        })
    }

    getSpielUpdateAfterTeamUpdate(teamDataObject, teamKey, isFreilos, path) {
        const freilosKey = teamKey + 'Freilos'
        const otherTeamKey = teamKey === 'team1' ? 'team2' : 'team1'
        const freilosKeyOtherTeam = otherTeamKey + 'Freilos'
        if( isFreilos || this[freilosKey] ) this.clearResult()
        this[teamKey] = isFreilos ? null : teamDataObject
        this[freilosKey] = isFreilos ? true : undefined
        this.winner = !isFreilos ? this[freilosKeyOtherTeam] ? teamKey : '' :
                                   this[otherTeamKey] ? otherTeamKey :
                                   this[freilosKeyOtherTeam] ? 'freilos' : ''
        return { [path + teamKey]: this[teamKey],
                 [path + freilosKey]: isFreilos ? true : 'firebase.firestore.FieldValue.delete()',
                [path + 'saetze']: JSON.parse(JSON.stringify(this.saetze)),
                [path + 'sv1']: this.sv1,
                [path + 'sv2']: this.sv2,
                [path + 'winner']: this.winner,
        }
    }
}